import React from 'react'

import { toTitleCase } from '../../../../../utilities'
import useStyles from './styles'

const OnlineProfile = ({ profile }) => {
  const formatted = React.useMemo(() => {
    if (!profile || typeof profile !== 'string') {
      return ''
    }

    const words = profile.split('_')
    const upper = words.map(word => toTitleCase(word))
    return upper.join(' ')
  }, [profile])

  const classes = useStyles({ profile })

  return <div className={classes.root}>{formatted}</div>
}

export default OnlineProfile
